function checkImageExists(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function () {
      resolve(true);
    };
    img.onerror = function () {
      resolve(false);
    };
    img.src = url;
  });
}

// import checkImageExists from '@/assets/scripts/checkImageExists.js';
// checkImageExists("/upload/playimg/231213101459283.png").then((res) => {
//       console.log(res);
//     });

export default checkImageExists;